var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGenerate = function SvgGenerate(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.75,
    d: "M0 15.5a.48.48 0 0 1 .148-.352l9.5-9.5A.48.48 0 0 1 10 5.5a.48.48 0 0 1 .352.148A.48.48 0 0 1 10.5 6a.48.48 0 0 1-.148.352l-9.5 9.5A.48.48 0 0 1 .5 16a.48.48 0 0 1-.352-.148A.48.48 0 0 1 0 15.5M11 0h1v2h-1zM9.383 3.086 7.96 1.672 8.67.96l1.415 1.422zM9 5H7V4h2zm2 2h1v2h-1zm2.617-1.086 1.422 1.414-.71.711-1.415-1.422zM16 4v1h-2V4zm-2.383-.914-.703-.703L14.328.96l.711.71zM11.5 4a.48.48 0 0 1 .352.148A.48.48 0 0 1 12 4.5a.48.48 0 0 1-.148.352A.48.48 0 0 1 11.5 5a.48.48 0 0 1-.352-.148A.48.48 0 0 1 11 4.5a.48.48 0 0 1 .148-.352A.48.48 0 0 1 11.5 4"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGenerate);
export { ForwardRef as ReactComponent };